<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="privacy-protection">
      <Title jpn="User guide" />
      <div class="scroll-container">
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title="1) Registering as a member"
        >
          <div class="text-container">
            <span class="text">To use this site, you need to register as a member (free of charge).</span>
            <span class="text">There are three ways to register as a member.</span>
            <span class="text">(1) Register with your Google account</span>
            <span class="text">(2) Register with your Apple account</span>
            <span class="text">(3) Register with your email address (Gmail recommended)</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title="2) Purchasing points"
          id="howtopay"
        >
          <div class="text-container">
            <span class="text">・All Gacha can be purchased with Gems.</span>
            <span class="text">・Therefore, please purchase Gems first.</span>
            <span class="text">・1 Gem = 1 yen, and you can choose from 300 Gems to 50,000 Gems. *There are 5 payment methods: credit card payment, PayPal, Amazonpay, UnionPay, and Alipay.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title="3) Purchasing"
          id="howtosend"
        >
          <div class="text-container">
            <span class="text">1. Tap the capsule you want.</span>
            <span class="text">2. A movie will play.</span>
            <span class="text">3. You will see the item you won.</span>
            <span class="text">4. For each item, please choose whether to “Convert to Gems” or “Request Shipment”. Please note that you cannot change your choice after you have made it. If you do not make a choice within 24 hours, the item will automatically be “Converted to Gems”. Please understand this in advance.</span>
            <br>
            <span class="text">If you choose “Convert to Gem”, we will give you Gems that you can use on this site in exchange for the item that was dispensed.</span>
            <br>
            <span class="text">If you choose “Shipment Request”, we will ship the winning card by FedEx within 14 days in principle. *We cannot be held responsible for any loss during the shipping process. Please be sure to contact FedEx. We apologize for the inconvenience.</span>
          </div>
        </ShadowBoxTitleDescription>
      </div>
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import ShadowBoxTitleDescription from '@/components/molecules/ShadowBoxTitleDescription.vue';
import Title from '@/components/molecules/Title.vue';
import t from '@/plugins/i18n';

export default {
  name: 'UserGuide',
  mixins: [t],

  components: {
    BaseTemplate,
    ShadowBoxTitleDescription,
    Title,
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
    }),
  },

  created() {
    this.$store.dispatch('user/setCurrentUser', { token: 'yugi' });
  },
};
</script>

<style lang="scss" scoped>
.privacy-protection{
  width: 100%;
  max-width: 1200px;
  padding: 30px 20px 0px;
  margin: 0px auto;
  color: $white;
  @include appendMap($backgroundStyleMap);
  .privacy-protection-title{
    display: flex;
    justify-content: center;
    .text{
      height: 35px;
      font-family: $notoSerif;
      font-size: 24px;
      font-weight: 700;
    }
  }
  .scroll-container{
    width: 100%;
    margin-top: 30px;
    padding-bottom: 50px;
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
    .shadow-box-title-description{
      width: 100%;
      .text-container{
        display: flex;
        flex-direction: column;
        padding: 5px 5px 0px 5px;
        .text{
          font-family: $notoSans;
          font-size: 13px;
          line-height: 1.5;
          letter-spacing: 0.03em;
          color: $white;
          a {
            color: $white!important;
          }
          &.margin-top{
            margin-top: 10px;
          }
          &.one-line-space-top{
            margin-top: 1em;
          }
          &.indent{
            padding-left: 2.6em;
            text-indent: -1.6em;
          }
        }
      }
      & + .shadow-box-title-description{
        margin-top: 40px;
      }
    }
  }
  .center {
    text-align: left;
  }
}
</style>
